<script context="module" lang="ts">
export type Breadcrumb = {
	label: string;
	href: string;
};
</script>

<script lang="ts">
  import { page } from "$app/stores";
  import { onMount } from "svelte";
  import JsonLd from "./json-ld.svelte";
  import { buildBreadcrumbListJsonLd } from "$lib/seo/structured-data";

  export let breadcrumbs: Breadcrumb[]

  let pathname: string

  onMount(() => {
    pathname = $page.url.pathname
  })

  $: breadcrumbJsonLd = buildBreadcrumbListJsonLd(breadcrumbs);
</script>

<JsonLd data={breadcrumbJsonLd} />

<nav class="py-2 px-4 sm:px-10 bg-bgGray">
  <ol class="flex flex-wrap gap-1">
    {#each breadcrumbs as { label, href }, index}
      <li class="text-sm tracking-wide flex gap-1 items-center">
        {#if index !== 0}
          <span class="w-[5px] h-[8px] mx-1">
            <svg viewBox="0 0 5 8" xmlns="http://www.w3.org/2000/svg">
              <path d="M.71 0 .27.44l3.54 3.54L.27 7.52l.44.44L4.7 3.98.71 0z" fill="#081018b2"></path>
            </svg>
          </span>
        {/if}
        <a href={href} data-current={href === pathname} class="data-[current=false]:underline">
          {label}
        </a>
      </li>
    {/each}
  </ol>
</nav>